import React, { useState, useEffect } from 'react';
import { useRecoilState } from 'recoil';
import { progressFlgState } from '../../GlobalState';
import {
  useStyles,
  ModalSubmitButton,
  ModalInnerButton
} from '../parts/cloudStorage/style/style';
import {
  getPictureDetailsById,
  downloadPictureById,
  editPictureDetailById
} from '../../apicalls/cloud/cloudPicture';
import { Grid, TextField } from '@material-ui/core';
import GetAppIcon from '@material-ui/icons/GetApp';
import CloseIcon from '@material-ui/icons/Close';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import IconButton from '@material-ui/core/IconButton';

import {
  formatDatetime,
  formatDataSize,
  checkResData
} from '../../utils/common';
import { useSnackbar } from 'notistack';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

type TProps = {
  pictureId: any;
  pictureList: any[];
  currentIndex: number;
  setCurrentIndex: (index: number) => void;
  folderName: string;
  getFolderPictureList: any;
  openDetailModal: boolean;
  setOpenDetailModal: React.Dispatch<React.SetStateAction<boolean>>;
};

//写真詳細表示
export const PictureDetailField: React.FC<TProps> = (props: TProps) => {
  const {
    setOpenDetailModal,
    pictureId,
    folderName,
    getFolderPictureList,
    currentIndex,
    setCurrentIndex
  } = props;

  const classes = useStyles();

  // メッセージ
  const { enqueueSnackbar } = useSnackbar();

  // ファイル詳細用
  const [pictureDetail, setPictureDetail] = useState<any>([]);

  const [src, setSrc] = useState<string>('');
  const [, setProgressFlg] = useRecoilState<boolean>(progressFlgState);

  // ファイル詳細編集用 -react hook from 実装後に不要
  const [pictureDetailShootingDate, setPictureDetailShootingDate] =
    useState<any>('');
  const [pictureDetailDescription, setPictureDetailDescription] =
    useState<string>('');

  //写真の詳細を取得
  const getPictureDetail = (index: number, showProgress = false) => {
    const id = props.pictureList[index];
    setCurrentIndex(index);
    //左右のナビゲーション時にはローディング画面を表示しない
    if (showProgress) setProgressFlg(true);

    getPictureDetailsById(id).then(resData => {
      checkResData(resData, enqueueSnackbar).then((data: any) => {
        setPictureDetail(data.data);
        setPictureDetailShootingDate(data.data.shooting_date);
        setPictureDetailDescription(
          data.data.description ? data.data.description : ''
        );
        //写真ダウンロード
        downloadPictureById(id).then(resData => {
          checkResData(resData, enqueueSnackbar).then((data: any) => {
            const imageData = data.data_for_display ?? data.data;
            const fileFormat = data.file_format_for_display ?? data.file_format;
            setSrc(
              `data:${fileFormat};base64,${imageData.replace(/^.*,/, '')}`
            );
          });
          if (showProgress) setProgressFlg(false);
        });
      });
    });
  };

  //写真ダウンロード
  const downloadPicture = (id: number, documentTypeDetail: string) => {
    setProgressFlg(true);
    downloadPictureById(id).then(resData => {
      checkResData(resData, enqueueSnackbar).then((data: any) => {
        let bin = atob(data.data.replace(/^.*,/, ''));

        let buffer = new Uint8Array(bin.length);
        for (let i = 0; i < bin.length; i++) {
          buffer[i] = bin.charCodeAt(i);
        }

        let image_file = new File([buffer.buffer], data.data, {
          type: data.file_format
        });

        const downloadLink = document.createElement('a');
        downloadLink.href = URL.createObjectURL(image_file);
        const fileName = `${pictureDetail.file_name}`;
        downloadLink.download = fileName;
        downloadLink.click();
      });
      setProgressFlg(false);
    });
  };

  // 写真更新
  const editPicture = () => {
    editPictureDetailById(
      pictureId,
      pictureDetailShootingDate,
      pictureDetailDescription,
      pictureDetail.file_name
    ).then(resData => {
      checkResData(resData, enqueueSnackbar).then((data: any) => {
        getFolderPictureList();
        setTimeout(() => {
          setOpenDetailModal(false);
        }, 2000);
      });
    });
  };

  // サイズ調整
  const theme = useTheme();
  const isWideScreen = useMediaQuery(theme.breakpoints.up('sm'));

  //ページ開いた時に実行
  useEffect(() => {
    getPictureDetail(currentIndex, true);
  }, []);

  return (
    <>
      <form className={classes.paper}>
        <Grid container>
          {/* クローズボタン */}
          <Grid
            item
            xs={12}
            style={{ display: 'flex', justifyContent: 'end', padding: 20 }}
          >
            <CloseIcon
              style={{ fontSize: 36, cursor: 'pointer' }}
              onClick={() => {
                setOpenDetailModal(false);
              }}
            />
          </Grid>

          <div
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'center',
              alignItems: 'center',
              overflow: 'hidden',
              width: '100%'
            }}
          >
            <div
              style={{
                width: isWideScreen ? '50%' : '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}
            >
              {/* モーダル左側 */}
              <Grid item className={classes.pictureArea}>
                <img
                  src={src}
                  alt='取得画像'
                  style={{
                    width: '85%',
                    objectFit: 'contain'
                  }}
                />
              </Grid>
            </div>

            <div style={{ width: isWideScreen ? '50%' : '100%' }}>
              {/* モーダル右側 */}
              <Grid item className={classes.modalRight}>
                <div style={{ margin: '24px 0px' }}>
                  <span style={{ marginRight: 12, marginBottom: 8 }}>
                    フォルダ
                  </span>
                  {folderName}
                </div>
                <div style={{ margin: '24px 0px' }}>
                  <span style={{ marginRight: 12, marginBottom: 8 }}>
                    作成日
                  </span>
                  {formatDatetime(
                    new Date(pictureDetail.created_at),
                    'YYYY.MM.DD',
                    '日本標準時'
                  )}
                </div>
                <div style={{ margin: '24px 0px' }}>
                  <span style={{ marginRight: 12 }}>作成者</span>
                  {pictureDetail.created_name}
                </div>
                <div style={{ margin: '24px 0px' }}>
                  <span style={{ marginRight: 12 }}>サイズ</span>
                  {formatDataSize(pictureDetail.size)}
                </div>

                <div style={{ marginTop: 24 }}>
                  <ModalInnerButton
                    onClick={() => {
                      downloadPicture(pictureDetail.id, pictureDetail.name);
                    }}
                  >
                    <GetAppIcon />
                    ダウンロード
                  </ModalInnerButton>
                </div>
              </Grid>
            </div>
          </div>

          <div className={classes.width100}>
            <Grid item>
              <div
                style={{
                  display: 'flex',
                  flexDirection: isWideScreen ? 'row' : 'column',
                  margin: 20
                }}
              >
                <div className={classes.tableHead} style={{ margin: 5 }}>
                  撮影日
                </div>
                <div className={classes.width100}>
                  <TextField
                    variant='outlined'
                    type='date'
                    value={pictureDetailShootingDate}
                    onChange={e => {
                      setPictureDetailShootingDate(e.target.value);
                    }}
                    inputProps={{
                      style: {
                        padding: '0 14px'
                      }
                    }}
                  />
                </div>
              </div>

              <div
                style={{
                  display: 'flex',
                  flexDirection: isWideScreen ? 'row' : 'column',
                  margin: 20
                }}
              >
                <div className={classes.tableHead} style={{ margin: 5 }}>
                  説明
                </div>
                <div className={classes.width100}>
                  <TextField
                    variant='outlined'
                    placeholder={'200文字以内'}
                    value={pictureDetailDescription}
                    rows={3}
                    multiline={true}
                    fullWidth={true}
                    onChange={e => {
                      setPictureDetailDescription(e.target.value);
                    }}
                    inputProps={{
                      maxLength: 200
                    }}
                  />
                </div>
              </div>
            </Grid>
          </div>

          {/* モーダルフッター */}
          <Grid item xs={12} className={classes.modalFooter}>
            <ModalSubmitButton
              variant='contained'
              onClick={() => {
                editPicture();
              }}
            >
              更新する
            </ModalSubmitButton>
            {/* 左右のナビゲーション矢印ボタン */}
            <IconButton
              onClick={() => getPictureDetail(currentIndex - 1)}
              disabled={currentIndex === 0}
              className={`${classes.navButton} ${classes.navLeft}`}
            >
              <ChevronLeftIcon fontSize='large' />
            </IconButton>
            <IconButton
              onClick={() => getPictureDetail(currentIndex + 1)}
              disabled={currentIndex === props.pictureList.length - 1}
              className={`${classes.navButton} ${classes.navRight}`}
            >
              <ChevronRightIcon fontSize='large' />
            </IconButton>
          </Grid>
        </Grid>
      </form>
    </>
  );
};
